import React from 'react';
import { Card, Button, Row, Col } from 'react-bootstrap';

function ProjectCard(props) {
	return (
		<Card className='project-card-view'>
			<Card.Img variant='top' src={props.imgPath} alt='card-img' />
			<Card.Body>
				<Card.Title className={'color2'}>{props.title}</Card.Title>
				<Card.Text style={{ textAlign: 'justify' }}>
					{props.description}
				</Card.Text>
				<Row>
					<Col className={'pl-1 pr-1 pb-2'}>
						<Button variant='primary' href={props.linkgit} target='_blank'>
							<i className='cil-external-link'>&nbsp;</i> View Project
						</Button>
					</Col>
					{props.linklive && <Col className={'pl-1 pr-0'}>
						<Button variant='primary' href={props.linklive} target='_blank'>
							<i className='cil-external-link'>&nbsp;</i> Live Demo
						</Button>
					</Col>}
				</Row>
			</Card.Body>
		</Card>
	);
}
export default ProjectCard;